import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import FreelancePageWrapper from '../../../../../shared/components/Styled/Containers/FreelancePageWrapper.jsx'
import FreelancePage from '../../../../../shared/components/Styled/Containers/FreelancePage.jsx'

import CvDataComparisonForm from './CvDataComparisonForm.jsx'

class CvDataComparison extends Component {
  constructor(props) {
    super(props)

    if (props.location.state) {
      this.state = { redirect: false }
      return
    }

    try {
      const stored = sessionStorage.getItem('cv_analysis_pending')
      if (stored) {
        const parsed = JSON.parse(stored)
        if (parsed.analyse) {
          this.resolvedState = parsed
          sessionStorage.removeItem('cv_analysis_pending')
          this.state = { redirect: false }
          return
        }
      }
    } catch (e) {
      console.warn('error', e)
    }

    this.state = { redirect: true }
  }

  static propTypes = {
    location: PropTypes.shape({
      state: PropTypes.shape({
        analyse: PropTypes.object.isRequired,
        freelance: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
      }),
    }).isRequired,
    history: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    match: PropTypes.object,
  }

  resolvePageState = () => {
    if (this.props.location.state) {
      return this.props.location.state
    }
    const { analyse } = this.resolvedState ?? {}
    return {
      analyse,
      freelance: this.props.currentFreelance,
      user: this.props.currentUser,
    }
  }

  handleSave = () => {
    const { freelance } = this.resolvePageState()
    this.props.history.push(`/freelance/${freelance.id}`)
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/errors/404" />
    }

    const { analyse, freelance, user } = this.resolvePageState()

    return (
      <FreelancePageWrapper>
        <FreelancePage className="cv-data-comparison p-5">
          <CvDataComparisonForm
            analyse={analyse}
            freelance={freelance}
            user={user}
            onSave={this.handleSave}
          />
        </FreelancePage>
      </FreelancePageWrapper>
    )
  }
}

export default connect(state => ({
  currentUser: state.currentUser.user,
  currentFreelance: state.currentUser.freelance,
}))(CvDataComparison)
